import type { SystemRole } from "@/isomorphic/schemas/profile";

const BETA_ACCESS_ROLES = new Set<SystemRole>(["beta-user", "admin", "super-admin"]);
const ADMIN_ROLES = new Set<SystemRole>(["admin", "super-admin"]);

export function hasBetaAccessRole(role: SystemRole | null | undefined): boolean {
  return role ? BETA_ACCESS_ROLES.has(role) : false;
}

export function isAdminSystemRole(role: SystemRole | null | undefined): boolean {
  return role ? ADMIN_ROLES.has(role) : false;
}

export function isSuperAdminSystemRole(role: SystemRole | null | undefined): boolean {
  return role === "super-admin";
}
